<template>
  <MenuCard title="Display" tooltip="Display settings will help you debug the model">
      <v-card-text class="">
        <div>
          <Row title="Skeleton">
              <v-switch class="ma-0" v-model="isShowSkeleton" hide-details></v-switch>
          </Row>
          <Row title="Wireframe">
              <v-switch class="ma-0" v-model="isShowWireframe" hide-details></v-switch>
          </Row>
          <Row title="Grid">
              <v-switch class="ma-0" v-model="isShowGrid" hide-details></v-switch>
          </Row>
          <Row title="Normal Map">
              <v-switch class="ma-0" v-model="isShowNormals" hide-details></v-switch>
          </Row>
          <!-- <Row title="Anti Aliasing">
              <v-switch class="ma-0" v-model="isAntiAlias" hide-details></v-switch>
          </Row> -->
          <Row title="Canvas Zoom">
            <NumberController v-model="canvasZoom"></NumberController>
          </Row>
          <Row title="Background Color">
            <ColorPicker v-model="backgroundColor"></ColorPicker>
          </Row>
        </div>
      </v-card-text>
  </MenuCard>
</template>

<script>
import MenuCard from './MenuCard.vue'
import Row from './Row.vue'
import NumberController from './NumberController.vue'
import ColorPicker from './ColorPicker.vue'

  export default {
    name: 'DisplayMenu',
    components: {
        MenuCard,
        Row,
        NumberController,
        ColorPicker,
    },
    methods: {
    },
    
    mounted() {
    },

    data: function () {
        return { };
    },

    props: [],
    watch: {
    },

    computed: {
        isShowSkeleton: {
            get() {
                return this.$store.state.isShowSkeleton;
            },
            set(value) {
                this.$store.commit('setIsShowSkeleton', value);
            },
        },
        isShowWireframe: {
            get() {
                return this.$store.state.isShowWireframe;
            },
            set(value) {
                this.$store.commit('setIsShowWireframe', value);
            },
        },
        isShowGrid: {
            get() {
                return this.$store.state.isShowGrid;
            },
            set(value) {
                this.$store.commit('setIsShowGrid', value);
            },
        },
        isShowNormals: {
            get() {
                return this.$store.state.isShowNormals;
            },
            set(value) {
                this.$store.commit('setIsShowNormals', value);
            },
        },
        isAntiAlias: {
            get() {
                return this.$store.state.isAntiAlias;
            },
            set(value) {
                this.$store.commit('setIsAntiAlias', value);
            },
        },
        canvasZoom: {
            get() {
                return this.$store.state.canvasZoom;
            },
            set(value) {
                this.$store.commit('setCanvasZoom', value);
            },
        },
        backgroundColor: {
            get() {
                return this.$store.state.backgroundColor;
            },
            set(value) {
                this.$store.commit('setBackgroundColor', value);
            },
        }
    },
  }
</script>


